import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { formatPrice } from '../helpers';
import hideFromRoutes from '../hoc/hideFromRoutes';


const Total = ({ total, subtotal, bookingFee, bookingFeeMessage }) => (
  <div className="total">
    { bookingFee !== null && bookingFee > 0
      ? <Fragment>
          <p className="total__price"><span className="total__text">Cargo por servicio: </span> <span className="total__num">{formatPrice(bookingFee)} €</span></p>
          <p className="total__price"><span className="total__text">Subtotal: </span> <span className="total__num">{formatPrice(subtotal)} €</span></p>
        </Fragment>
                // : <p className="text text--small">{ bookingFeeMessage !== '' ? `*${bookingFeeMessage}` : ''}</p>
        : <p className="text text--small">{ bookingFeeMessage !== '' ? `` : ''}</p>
    }
    <p className="total__price"><span className="total__text">Total (Impuestos Incluidos): </span> <span className="total__num">{formatPrice(total)} €</span></p>
    <p className='total_price_tax'>Gastos de gestión, IVA/IGIC y recargos incluidos, <a href='https://eu-static.yelmocines.es/content/pdf/extended-synopsis/Gastos-de-Gestion.pdf' target="_blank" rel="noopener noreferrer">ver detalles</a>
    </p>
  </div>
);

const mapStateToProps = ({ tickets, seats, showtime }) => {
  const { seatsSelectedResponse } = seats;

  let message = "";
  if (showtime.showtimeInfo && showtime.showtimeInfo.alerts) {
    const alertMessage = showtime.showtimeInfo.alerts.find(x => x.section == "booking-fee");
    if (alertMessage) {
      message = alertMessage.message;  
    }
  }

  if (message === "") {
    if (showtime.settings !== null && showtime.settings.others !== null) {
      message = showtime.settings.others.booking_fee_message;  
    }    
  }

  return {
    subtotal: seatsSelectedResponse.subtotal_value && seatsSelectedResponse.subtotal_value ? seatsSelectedResponse.subtotal_value : null,
    bookingFee: seatsSelectedResponse.booking_fee_value && seatsSelectedResponse.booking_fee_value ? parseInt(seatsSelectedResponse.booking_fee_value, 10) : 0,
    bookingFeeMessage: message,
    total: seatsSelectedResponse.total_value && seatsSelectedResponse.total_value ? parseInt(seatsSelectedResponse.total_value,10) : tickets.total
  };
};
export default hideFromRoutes(connect(
  mapStateToProps
)(Total), ['/error', '/']);

